import React from 'react';
import { Menu } from 'antd';
import Overview from './Overview/Overview';
import Links from './Links/Links';

ProfileEditor.propTypes = {};

const MenuKeys = {
	overview: 'overview',
	links: 'links',
};

export default function ProfileEditor() {
	const defaultSelectedKey = MenuKeys.overview;

	const [selectedKey, setSelectedKey] = React.useState(defaultSelectedKey);

	const handleMenuSelectionChange = event => {
		setSelectedKey(event.key);
	};

	const menuItems = [
		{
			key: MenuKeys.overview,
			label: 'Overview',
		},
		{
			key: MenuKeys.links,
			label: 'Links',
		},
	];

	const getMenuSelectionView = () => {
		switch (selectedKey) {
			case MenuKeys.overview:
				return <Overview />;
			case MenuKeys.links:
				return <Links />;
		}
	};

	return (
		<div className="profile-editor">
			<Menu
				onClick={handleMenuSelectionChange}
				style={{ width: 200 }}
				defaultSelectedKeys={[defaultSelectedKey]}
				mode="inline">
				{menuItems.map(menuItem => (
					<Menu.Item key={menuItem.key}>{menuItem.label}</Menu.Item>
				))}
			</Menu>
			<div className="menu-selection-view">{getMenuSelectionView()}</div>
		</div>
	);
}
